/** Shopify CDN: Minification failed

Line 17:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 19:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 19:45 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 20:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 31:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 40:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 47:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 48:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 49:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 50:4 Transforming const to the configured target environment ("es5") is not supported yet
... and 104 more hidden warnings

**/
(() => {
  const productCartItems = new WeakMap();

  const pushEvent = (section, event, details = {}) => {
    const payload = {
      event,
      campaign_key: section.dataset.campaignKey || "unknown",
      ...details,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    section.dispatchEvent(new CustomEvent("ecomwerk:ad-landing", { bubbles: true, detail: payload }));
  };

  const parseProductData = (product) => {
    try {
      return JSON.parse(product.querySelector("[data-ew-product-data]")?.textContent || "{}");
    } catch (error) {
      console.error("Ecomwerk Landingpage: Produktdaten konnten nicht gelesen werden.", error);
      return { variants: [], preorder: {} };
    }
  };

  const isPreorderVariant = (variant, preorder) => Boolean(
    preorder?.enabled
      && variant?.inventoryManagement
      && variant?.inventoryPolicy === "continue"
      && Number(variant?.inventoryQuantity) <= 0
  );

  const initProduct = (product) => {
    const data = parseProductData(product);
    const variants = Array.isArray(data.variants) ? data.variants : [];
    const optionControls = [...product.querySelectorAll("[data-ew-option]")];
    const variantInput = product.querySelector("[data-ew-variant]");
    const price = product.querySelector("[data-ew-price]");
    const image = product.querySelector(".ew-ad-lp__product-image");
    const preorderNotice = product.querySelector("[data-ew-preorder]");
    const soldOutSuffix = " \u2013 Ausverkauft";
    let variantAvailabilityNotice = product.querySelector("[data-ew-variant-availability]");

    if (!variantAvailabilityNotice && optionControls.length) {
      variantAvailabilityNotice = document.createElement("span");
      variantAvailabilityNotice.className = "ew-ad-lp__sold-out";
      variantAvailabilityNotice.dataset.ewVariantAvailability = "";
      variantAvailabilityNotice.setAttribute("role", "status");
      variantAvailabilityNotice.setAttribute("aria-live", "polite");
      variantAvailabilityNotice.hidden = true;
      const productCopy = product.querySelector(".ew-ad-lp__product-copy");
      if (productCopy) productCopy.insertBefore(variantAvailabilityNotice, preorderNotice || null);
    }

    const selectedValues = () => {
      const values = [];
      optionControls.forEach((control) => {
        values[Number(control.dataset.optionPosition)] = control.value;
      });
      return values;
    };

    const matchesPartialSelection = (variant, values) => values.every((value, index) => !value || variant.options?.[index] === value);

    const updateOptionAvailability = (clearedSelections = []) => {
      let changed = false;
      optionControls.forEach((control) => {
        if (control.tagName !== "SELECT") return;
        const position = Number(control.dataset.optionPosition);
        const currentValues = selectedValues();
        [...control.options].forEach((option) => {
          if (!option.value) return;
          const baseLabel = option.dataset.ewBaseLabel || option.textContent.replace(soldOutSuffix, "");
          option.dataset.ewBaseLabel = baseLabel;
          const candidateValues = [...currentValues];
          candidateValues[position] = option.value;
          const available = variants.some((variant) => variant.available && matchesPartialSelection(variant, candidateValues));
          option.disabled = !available;
          option.textContent = available ? baseLabel : `${baseLabel}${soldOutSuffix}`;
        });

        const selectedOption = [...control.options].find((option) => option.value === control.value);
        if (control.value && selectedOption?.disabled) {
          clearedSelections.push({
            optionName: control.dataset.optionName || "Variante",
            value: selectedOption.dataset.ewBaseLabel || selectedOption.value,
          });
          control.selectedIndex = 0;
          control.value = "";
          changed = true;
        }
      });
      if (changed) updateOptionAvailability(clearedSelections);
      return clearedSelections;
    };

    const updateResolvedVariant = () => {
      const clearedSelections = updateOptionAvailability();
      const values = selectedValues();
      let variant = null;

      if (!optionControls.length && variantInput?.value) {
        variant = variants.find((candidate) => String(candidate.id) === String(variantInput.value)) || null;
      } else if (values.length && values.every(Boolean)) {
        variant = variants.find((candidate) => candidate.available && candidate.options?.every((value, index) => value === values[index])) || null;
      }

      if (variantInput) variantInput.value = variant ? String(variant.id) : "";
      if (variant?.price && price) price.textContent = variant.price;
      if (variant?.image && image) {
        image.removeAttribute("srcset");
        image.removeAttribute("sizes");
        image.src = variant.image;
      }

      const preorderActive = variant
        ? isPreorderVariant(variant, data.preorder)
        : Boolean(data.preorder?.possible);
      product.dataset.ewPreorder = preorderActive ? "true" : "false";
      if (preorderNotice) preorderNotice.hidden = !preorderActive;
      if (variantAvailabilityNotice) {
        if (clearedSelections.length) {
          const cleared = clearedSelections[0];
          variantAvailabilityNotice.textContent = `${cleared.optionName} ${cleared.value} ist f\u00fcr diese Auswahl ausverkauft. Bitte w\u00e4hle eine andere Variante.`;
          variantAvailabilityNotice.hidden = false;
        } else {
          variantAvailabilityNotice.textContent = "";
          variantAvailabilityNotice.hidden = true;
        }
      }
      product.dispatchEvent(new CustomEvent("ecomwerk:variant-resolved", { bubbles: true, detail: { variant, preorderActive } }));
      return variant;
    };

    optionControls.forEach((control) => control.addEventListener("change", updateResolvedVariant));
    updateResolvedVariant();

    productCartItems.set(product, () => {
      const variantId = variantInput?.value;
      if (!variantId) return null;
      const variant = variants.find((candidate) => String(candidate.id) === String(variantId));
      const item = { id: String(variantId), quantity: 1 };

      if (isPreorderVariant(variant, data.preorder)) {
        item.properties = {
          [data.preorder.propertyFlag || "_Vorverkauf"]: data.preorder.propertyFlagValue || "Ja",
        };
        if (data.preorder.deliveryLabel) {
          item.properties[data.preorder.propertyDelivery || "Voraussichtliche Lieferung"] = data.preorder.deliveryLabel;
        }
      }

      return item;
    });
  };

  const initSection = (section) => {
    if (section.dataset.ewInitialized === "true") return;
    section.dataset.ewInitialized = "true";
    document.documentElement.classList.add("ew-ad-landing-active");

    const lookTrack = section.querySelector("[data-ew-look-track]");
    const looks = [...section.querySelectorAll("[data-ew-look]")];
    const lookDialog = section.querySelector("[data-ew-look-dialog]");
    const lookDialogImage = section.querySelector("[data-ew-dialog-image]");
    const lookDialogCaption = section.querySelector("[data-ew-dialog-caption]");
    const stickyCta = section.querySelector(".ew-ad-lp__sticky-cta");
    const heroPrimaryCta = section.querySelector('[data-ew-track="hero_primary"]');
    const looksSection = section.querySelector(".ew-ad-lp__looks-section");

    section.querySelectorAll("[data-ew-product]").forEach(initProduct);

    section.querySelectorAll("[data-ew-expand-look]").forEach((button) => {
      button.addEventListener("click", () => {
        const sourceImage = button.querySelector("img");
        if (!lookDialog || !lookDialogImage || !sourceImage) return;
        const look = button.closest("[data-ew-look]");
        lookDialogImage.src = sourceImage.currentSrc || sourceImage.src;
        lookDialogImage.alt = sourceImage.alt || look?.querySelector("h3")?.textContent.trim() || "Vollständiger Look";
        if (lookDialogCaption) lookDialogCaption.textContent = look?.querySelector("h3")?.textContent.trim() || "";
        if (typeof lookDialog.showModal === "function") lookDialog.showModal();
        else lookDialog.setAttribute("open", "");
        pushEvent(section, "ew_ad_landing_look_expand", { look_key: look?.dataset.lookKey || "unknown" });
      });
    });

    const closeLookDialog = () => {
      if (!lookDialog) return;
      if (typeof lookDialog.close === "function") lookDialog.close();
      else lookDialog.removeAttribute("open");
    };
    section.querySelector("[data-ew-close-look]")?.addEventListener("click", closeLookDialog);
    lookDialog?.addEventListener("click", (event) => {
      if (event.target === lookDialog) closeLookDialog();
    });

    const syncStickyCta = () => {
      if (!stickyCta || !looksSection) return;
      const showAfter = heroPrimaryCta ? heroPrimaryCta.getBoundingClientRect().bottom + window.scrollY : 0;
      const hideAfter = looksSection.getBoundingClientRect().top + window.scrollY - window.innerHeight * 0.45;
      stickyCta.classList.toggle("is-hidden", window.scrollY < showAfter || window.scrollY >= hideAfter);
    };

    if (stickyCta && looksSection) {
      window.addEventListener("scroll", syncStickyCta, { passive: true });
      window.addEventListener("resize", syncStickyCta, { passive: true });
      syncStickyCta();
    }

    const syncPreviewBar = () => section.classList.toggle("ew-ad-lp--preview-bar", Boolean(document.querySelector("#PBarNextFrameWrapper")));
    syncPreviewBar();
    if (!section.classList.contains("ew-ad-lp--preview-bar") && document.body) {
      const previewObserver = new MutationObserver(() => {
        syncPreviewBar();
        if (section.classList.contains("ew-ad-lp--preview-bar")) previewObserver.disconnect();
      });
      previewObserver.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(() => previewObserver.disconnect(), 8000);
    }

    const clearResolvedSelectionStatus = (look) => {
      const status = look?.querySelector("[data-ew-status]");
      if (!status?.textContent.startsWith("Bitte wähle")) return;
      const selectedProducts = [...look.querySelectorAll("[data-ew-product]")]
        .filter((product) => product.querySelector("[data-ew-product-toggle]")?.checked);
      if (selectedProducts.length && selectedProducts.every((product) => product.querySelector("[data-ew-variant]")?.value)) {
        status.textContent = "";
      }
    };

    section.querySelectorAll("[data-ew-track]").forEach((link) => {
      link.addEventListener("click", () => pushEvent(section, "ew_ad_landing_cta", { placement: link.dataset.ewTrack }));
    });

    section.addEventListener("ecomwerk:variant-resolved", (event) => {
      clearResolvedSelectionStatus(event.target.closest("[data-ew-look]"));
    });

    section.querySelectorAll("[data-ew-product-toggle]").forEach((toggle) => {
      toggle.addEventListener("change", () => {
        const product = toggle.closest("[data-ew-product]");
        product?.classList.toggle("is-unselected", !toggle.checked);
        clearResolvedSelectionStatus(product?.closest("[data-ew-look]"));
      });
    });

    section.querySelectorAll("[data-ew-add-look]").forEach((button) => {
      button.addEventListener("click", async () => {
        const look = button.closest("[data-ew-look]");
        const status = look?.querySelector("[data-ew-status]");
        const label = button.querySelector("[data-ew-button-label]");
        const selectedProducts = [...(look?.querySelectorAll("[data-ew-product]") || [])]
          .filter((product) => product.querySelector("[data-ew-product-toggle]")?.checked);
        const missingVariant = selectedProducts.find((product) => !product.querySelector("[data-ew-variant]")?.value);
        const items = selectedProducts.map((product) => productCartItems.get(product)?.()).filter(Boolean);

        if (!selectedProducts.length) {
          if (status) status.textContent = "Bitte wähle mindestens ein verfügbares Produkt.";
          return;
        }

        if (missingVariant || items.length !== selectedProducts.length) {
          const productTitle = missingVariant?.dataset.productTitle || "dieses Teil";
          if (status) status.textContent = `Bitte wähle die passende Grösse oder Variante für ${productTitle}.`;
          missingVariant?.querySelector("select[data-ew-option]")?.focus();
          return;
        }

        button.disabled = true;
        button.setAttribute("aria-busy", "true");
        if (status) status.textContent = "Der Look wird hinzugefügt …";

        try {
          const root = window.Shopify?.routes?.root || "/";
          const response = await fetch(`${root}cart/add.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ items }),
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || "Der Look konnte nicht hinzugefügt werden.");

          pushEvent(section, "ew_ad_landing_add_look", {
            look_key: look?.dataset.lookKey || "unknown",
            item_count: items.length,
            preorder_item_count: items.filter((item) => item.properties?._Vorverkauf === "Ja").length,
          });

          if (status) status.textContent = `${items.length} Teile wurden hinzugefügt.`;
          if (label) label.textContent = "Look hinzugefügt";
          document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: result }));

          if (section.dataset.cartBehavior === "cart") {
            window.location.assign(section.dataset.cartUrl || `${root}cart`);
          }
        } catch (error) {
          if (status) status.textContent = error instanceof Error ? error.message : "Bitte versuche es erneut.";
          button.disabled = false;
        } finally {
          button.removeAttribute("aria-busy");
        }
      });
    });

    if ("IntersectionObserver" in window) {
      const seen = new WeakSet();
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || seen.has(entry.target)) return;
          seen.add(entry.target);
          pushEvent(section, "ew_ad_landing_look_view", { look_key: entry.target.dataset.lookKey || "unknown" });
        });
      }, { threshold: 0.55 });
      looks.forEach((look) => observer.observe(look));
    }

    pushEvent(section, "ew_ad_landing_view");
  };

  const initAll = (root = document) => {
    if (root.matches?.("[data-ew-ad-landing]")) initSection(root);
    root.querySelectorAll?.("[data-ew-ad-landing]").forEach(initSection);
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initAll());
  else initAll();

  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
})();


(() => {
  const initializedTracks = new WeakSet();

  const initMobileLookGestures = (root = document) => {
    root.querySelectorAll?.("[data-ew-look-track]").forEach((track) => {
      if (initializedTracks.has(track)) return;
      initializedTracks.add(track);

      const looks = [...track.querySelectorAll("[data-ew-look]")];
      if (looks.length < 2) return;
      const lookLeft = (look) => look.offsetLeft - looks[0].offsetLeft;

      let navigation = track.parentElement?.querySelector(".ew-ad-lp__look-jump");
      if (!navigation) {
        navigation = document.createElement("nav");
        navigation.className = "ew-ad-lp__look-jump";
        navigation.setAttribute("aria-label", "Look auswählen");
        looks.forEach((look, index) => {
          const button = document.createElement("button");
          button.type = "button";
          button.textContent = `Look ${index + 1}`;
          button.classList.toggle("is-active", index === 0);
          button.setAttribute("aria-current", index === 0 ? "true" : "false");
          button.addEventListener("click", () => {
            track.scrollTo({ left: lookLeft(look), behavior: "smooth" });
          });
          navigation.append(button);
        });
        track.before(navigation);
      }

      const navigationButtons = [...navigation.querySelectorAll("button")];
      const syncNavigation = () => {
        const trackCenter = track.scrollLeft + track.clientWidth / 2;
        const activeIndex = looks.reduce((bestIndex, look, index) => {
          const currentDistance = Math.abs((look.offsetLeft + look.offsetWidth / 2) - trackCenter);
          const bestLook = looks[bestIndex];
          const bestDistance = Math.abs((bestLook.offsetLeft + bestLook.offsetWidth / 2) - trackCenter);
          return currentDistance < bestDistance ? index : bestIndex;
        }, 0);
        navigationButtons.forEach((button, index) => {
          const active = index === activeIndex;
          button.classList.toggle("is-active", active);
          button.setAttribute("aria-current", active ? "true" : "false");
        });
      };

      let scrollFrame = 0;
      track.addEventListener("scroll", () => {
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(syncNavigation);
      }, { passive: true });

      syncNavigation();
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initMobileLookGestures());
  } else {
    initMobileLookGestures();
  }
  document.addEventListener("shopify:section:load", (event) => initMobileLookGestures(event.target));
})();


(() => {
  if (!document.querySelector("[data-ew-ad-landing]")) return;

  const releaseKlaviyoScrollLock = () => {
    document.querySelectorAll("form.klaviyo-form").forEach((form) => {
      let wrapper = form.parentElement;
      while (wrapper && wrapper !== document.body) {
        if (getComputedStyle(wrapper).position === "fixed") {
          wrapper.remove();
          break;
        }
        wrapper = wrapper.parentElement;
      }
    });
    document.body.classList.remove("klaviyo-prevent-body-scrolling");
  };

  const observer = new MutationObserver(releaseKlaviyoScrollLock);
  observer.observe(document.body, { childList: true, subtree: true });
  releaseKlaviyoScrollLock();
  window.setTimeout(() => observer.disconnect(), 30000);
})();
